import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { IOrderTaskPost, IOrderTaskPostFilter, IPage } from 'src/app/xena-api';

@Injectable()
export class OrderTaskPostService {

  constructor(private xenaClient: XenaClient, private contextService: ContextService) {
  }

  list(filter: IOrderTaskPostFilter): Observable<IPage<IOrderTaskPost>> {
    const resourcePath: string = `/fiscal/${this.contextService.fiscalId}/orderTaskPost`;
    return this.xenaClient.list<IOrderTaskPost, IOrderTaskPostFilter>(resourcePath, filter)

  }
}
